/**
 * @module lib/commercial/keytar/newsletter-story-regwall
 */
import template from "./template";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { hasParameterMatch } from "lib/commercial/keytar/helpers";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";

const name = "newsletterStoryRegwall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isReg: () => customer.canAccessRegisteredContent
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used */
  matcher({ url }) {
    // Allow wall to be shown if utm_source parameter matches whitelisted parameters under runtime properties, regardless of paywall colour.
    return hasParameterMatch(url);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template
};

export default new Wall("newsletter-story-regwall", WALL_TYPES.REGWALL_HARD, props);
